<template>
  <div>
    <el-card class="box-card"
             :body-style="{ padding: '10px' }">
      <!-- 标题 -->
      <div style="font-size:16px; background:rgb(235, 236, 240); padding: 6px; ">{{schedulingName}}</div>
      <div>
        <!-- 查询区: 日/周/月, 日期, 查询按钮 -->
        <div style="padding-top: 5px;">
          <el-row>
            <el-col>
              <div style="float: left">
                <el-radio-group v-model="queryForm.radio"
                                @change="selectDate"
                                size="small">
                  <el-radio-button label="D">日</el-radio-button>
                </el-radio-group>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 日程表格 -->
        <div style="padding-top: 10px;">
          <el-row>
            <el-scrollbar class="scrollbar11">
              <div style="width:100%">
                <table style="border: 1px solid rgba(3, 12, 48, 0.164);" aria-describedby="">
                  <tr>
                    <td class="td-class"
                        v-if="schedulingList.length !== 0">&nbsp;</td>
                    <td v-for="(someone,index) in schedulingList"
                        :key="index"
                        class="td-class">
                      <div v-if="someone.isWeekend === '0'"
                           class="table_td_cell_not_scheduled">
                        {{someone.sectionTitle}}
                      </div>
                      <div v-else
                           class="table_td_cell_no_need_to_arrange">
                        {{someone.sectionTitle}}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-class"
                        v-if="schedulingList.length !== 0">{{resName}}</td>
                    <td v-for="(someone,index) in schedulingList"
                        :key="index"
                        class="td-class">
                      <div v-if="someone.bookResult === '1'"
                           class="table_td_cell_scheduled"
                           @click="onDetails(someone)">
                        &nbsp;
                      </div>
                      <div v-else-if="someone.isWeekend === '1'"
                           class="table_td_cell_no_need_to_arrange">
                        &nbsp;
                      </div>
                      <div v-else
                           class="table_td_cell_not_scheduled">
                        &nbsp;
                      </div>
                    </td>
                  </tr>

                </table>
              </div>
              <div style="height: 20px">&nbsp;</div>
            </el-scrollbar>
          </el-row>
          <el-row>
            <div style="height: 10px">&nbsp;</div>
          </el-row>
        </div>
        <!-- 排期 详情 -->
        <div style="margin: 6px;   border: 1px solid #000000; padding: 4px"
             v-if="isSchedule">
          <div style="font-size: 15px">日程安排详细</div>
          <el-scrollbar class="scrollbar11">
            <div style="height: 104px;">
              <table aria-describedby="">
                <tr v-for="(schedule, index) in scheduleMsgList"
                    :key="index">
                  <td>{{schedule.sectionTime}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <!--排期-->
                  <td style="color: #00BFFF; cursor: pointer;"
                      v-if = "schedule.bookType === '1'"
                      @click="showView(schedule)">{{schedule.courseName}}</td>
                  <!--调配-->
                  <td style="color: #00BFFF;"
                      v-if = "schedule.bookType === '2'">{{schedule.courseName}}</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{schedule.siteName}}</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{schedule.sessionCreatorName}}</td>
                </tr>
              </table>
            </div>
          </el-scrollbar>

        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'resouce-select',
  props: {
    // 日程安排 名称
    schedulingName: String,
    // 查询Id
    schedulingId: String,
    // 起始时间
    schedulingDateS: Date,
    // 结束时间
    schedulingDateE: Date,
    // 传入参数
    afferentParam: {
      type: Object
    }
  },
  data () {
    return {
      // 查询 条件
      queryForm: {
        schedulingDate: '',
        radio: 'D'
      },
      // 查询的 日程安排 List
      schedulingList: [],
      // 排期列表信息
      scheduleList: [],
      // 排期列表详情信息
      scheduleMsgList: [],
      // 显示 排序列表 开关
      isSchedule: false,
      resName: '',
      type: '',
      courseId: ''
    }
  },
  methods: {
    selectDate () {
      console.log(this.queryForm.radio)
    },
    // 查询明细
    onDetails (item) {
      this.isSchedule = false
      console.info('aaaaaaaaaa')
      console.info(item)
      console.info(this.courseId)
      console.info('bbbbbbbbbbb')
      // 这里 查看明细， 去后台
      let url = '/rm/schedule/queryBookList'
      let param = {
        'resId': item.resId,
        'linkBillId': this.courseId,
        'queryDateS': item.queryDate,
        'queryDateE': item.queryDate,
        'resType': this.type,
        'queryType': this.queryForm.radio
      }
      console.info('param ===> ', param)
      this.$request.post(
        url, param
      ).then((res, total, code, data) => {
        console.info('data.data点查看明细出来的值----------------->', data.data)
        this.scheduleMsgList = data.data
        this.isSchedule = true
        console.info(data)
      })
      this.$forceUpdate() // 页面重新刷新
    },
    // 跳转
    onJump (url) {
      this.$message('我跳转了, 跳转URL: ' + url)
    },
    // 查询 按钮 方法
    queryScheduling (data, dataQuery) {
      console.info('dataQuery ===> ', dataQuery)
      this.courseId = dataQuery.courseId
      this.isSchedule = false
      this.type = dataQuery.type
      let url = '/rm/schedule/queryResourceSchedule'
      let param = {
        'resType': dataQuery.type,
        'queryType': this.queryForm.radio,
        'resId': data.id,
        'resName': data.roomCnAbbr,
        'queryDateS': new Date(dataQuery.startTime.replace(/-/g, '\/')),
        'queryDateE': new Date(dataQuery.endTime.replace(/-/g, '\/'))
      }
      this.$request.post(
        url, param
      ).then((res, total, code, data) => {
        this.resName = data.data.resName
        this.schedulingList = data.data.bookItemDTOList
        console.info('查询')
        console.info(data.data)
        console.info('明细')
      })
      this.$forceUpdate() // 页面重新刷新
    },
    // 日程安排 Style
    getStatusStyle (status) {
      if (status === 'A') {
        return 'table_td_cell_not_scheduled'
      }
      if (status === 'B') {
        return 'table_td_cell_scheduled'
      }
      if (status === 'C') {
        return 'table_td_cell_no_need_to_arrange'
      }
    },
    // 查询 排期
    showSchedule (msg) {
      if (msg.length !== 0) {
        this.scheduleList = msg
        this.isSchedule = true
      } else {
        this.isSchedule = false
      }
    },
    // 查看
    showView (schedule) {
      let offeringId = schedule.sessionId
      // 通知最外层父组件关闭dialog
      this.$emit('closeResDialog', '')
      console.log(offeringId)
      // 延迟加载
      this.$nextTick(() => {
        this.$router.push({
          name: 'learning-offering-offeringShow',
          query: { offeringId: offeringId, isShowEdit : this.checkEditRole(schedule) }
        })
        this.$eventHub.$emit('showViewOffering', this.checkEditRole(schedule))
      })
    },

    // 校验排期查看按钮权限
    checkEditRole (row) {
      let userId = JSON.parse(sessionStorage.getItem('v1user_data')).userId
      if (row.offeringStatus === '30' || row.offeringStatus === '40') {
        return false
      }

      if(this.$hasPermission('learning:offering:editselfcreated')){
        if (row.createUser === userId ){
          return true
        }
      }else {
        if (this.$hasPermission('learning:offering:editselfcreated')) {
          return true
        }
        if (this.$hasPermission('learning:offering:offeringEdit')) {
          return true
        }
        if (this.$hasPermission('TEAM:' + row.courseTeamCatalogSecond)) {
          return true
        }
      }

      return false
    }
  }
}
</script>
<style>
#scrollbar11,
#scrollbar11 > .el-scrollbar__wrap {
  overflow-x: hidden !important;
}
/* 每个单元格设置 */
.td-class {
  border: 1px solid rgba(3, 12, 48, 0.164);
  width: 54px;
  white-space: nowrap;
}
/* 未安排 日程 */
.table_td_cell_not_scheduled {
  background-color: rgb(255, 255, 255);
  cursor: not-allowed;
}
/* 安排 日程 */
.table_td_cell_scheduled {
  background-color: rgb(27, 104, 210);
  cursor: pointer;
}
/* 不用安排 日程 */
.table_td_cell_no_need_to_arrange {
  background-color: rgba(3, 12, 48, 0.164);
  cursor: not-allowed;
}
</style>
<style scoped>
#scrollbar11 {
  height: 100%;
  width: 100%;
}
</style>
